var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogopaisaWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15884_317845",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15884_317845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1073 6.66602C18.8528 6.66602 21.8857 9.16907 21.8857 12.275C21.8857 15.381 18.8528 17.2629 15.1073 17.2629C11.4167 17.1898 8.84054 15.984 7.37891 13.6453C8.16454 9.22388 10.7407 6.90353 15.1073 6.66602ZM14.8515 10.1557C12.6956 10.3749 11.3801 11.3981 10.8868 13.2251C11.5446 13.8098 12.86 14.1204 14.8515 14.1934C16.843 14.1569 18.0306 13.5723 18.0671 12.2385C17.9392 10.7403 16.4959 10.1009 14.8515 10.1557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10389 15.125C8.20012 18.3041 11.2696 20.0763 14.4121 20.0763C17.0248 20.0763 18.7605 18.9618 19.6557 17.2444L22.579 19.0714C21.5741 21.5745 18.5412 23.3833 14.9785 23.3833C10.557 23.3833 6.79329 20.4234 7.10389 15.2529C7.10389 15.2164 7.10389 15.1798 7.10389 15.125Z",
    fill: "#31B454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogopaisaWallet);
export default __webpack_public_path__ + "static/media/logopaisaWallet.ac887885ed65c94501e2f00e97b4872f.svg";
export { ForwardRef as ReactComponent };